import React from "react";

export const RemoveIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg 
    xmlns   = "http://www.w3.org/2000/svg"
    viewBox = "0 0 24 24"
    width   = {props.width || "28"}
    fill    = {props.color || "currenColor"}
  >
    <path d="M0 0h24v24H0V0z" fill="none"/>
    <path d="M19 13H5v-2h14v2z"/>
  </svg>
);

